// JavaScript Document
jQuery(document).ready(function ($) {

  
    // Desktop Menu Scroll Event
    $('.main-navigation-wrapper ul li a').click(function (e) {
      var href = $(this).attr('href');
      console.log();
      if(href.indexOf('#') != -1) {
        e.preventDefault();
        document.location.href = "/" + href;
      }
    });

    // Mobile Menu Scroll Event
    $('.mobile-menu-wrapper ul li a').click(function (e) {
      var href = $(this).attr('href');
      console.log();
      if(href.indexOf('#') != -1) {
        e.preventDefault();
        document.location.href = "/" + href;
      }
    });
  
  
});